import { Playground } from 'docz';
import { useImage } from "../../../../../src/index";
import * as React from 'react';
export default {
  Playground,
  useImage,
  React
};